module.exports = __webpack_public_path__ + "static/transactionalemail-cta-dont-1e2377af546385ecbe1b85d2ac0d3a5e.png";